import { Component } from '@angular/core';
import { LocalService } from '../../../services/shared/local.service';

@Component({
  selector: 'app-lm-vessels',
  templateUrl: './lm-vessels.component.html',
  styleUrl: './lm-vessels.component.css'
})
export class LmVesselsComponent {
  constructor(private localService: LocalService) {
      this.localService.setIsCmSite(true);
    this.localService.setShowMenu(true)
    this.localService.setRouteName('sm-vessels');
  }
}
